import { render, staticRenderFns } from "./DashboardQuickAccessCard.vue?vue&type=template&id=4f45ce0e&"
import script from "./DashboardQuickAccessCard.vue?vue&type=script&lang=js&"
export * from "./DashboardQuickAccessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports